import { matchPath, useLocation } from 'react-router'
import { useUserRole, useUserSubscription } from 'shared/hooks'
import { UserRole } from 'shared/types'
import paths from 'config/paths'

const HIDDEN_BANNER_ROUTES = [paths.subscription, paths.subscriptionSummary]

export const useShowBanner = () => {
  const { subscriptionData, isLoading } = useUserSubscription()
  const { pathname } = useLocation()
  const { userType } = useUserRole()
  const hideBanner = HIDDEN_BANNER_ROUTES.some(route =>
    matchPath(pathname, route)
  )
  const isSubscriptionActive = !!subscriptionData.subscription

  return (
    !(isSubscriptionActive || hideBanner) &&
    userType === UserRole.User &&
    !isLoading
  )
}
